module.exports = __webpack_public_path__ + "static/media/logo_WK_footer.0bef8be7.svg";